var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 4.37209C0.78683 4.28002 0.75 4.16952 0.75 4.04062C0.75 3.93013 0.78683 3.81964 0.878906 3.72756L4.11998 0.63381C4.30413 0.468074 4.58036 0.468074 4.74609 0.652225C4.91183 0.817962 4.91183 1.1126 4.72768 1.27834L2.27846 3.59865H8.55804C8.79743 3.59865 9 3.80122 9 4.04062C9 4.29843 8.79743 4.48258 8.55804 4.48258H2.27846L4.72768 6.82131C4.91183 6.98705 4.91183 7.26327 4.74609 7.44743C4.58036 7.63158 4.30413 7.63158 4.11998 7.46584L0.878906 4.37209Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8b1da288c18ca8df3f2b9c98ca440c82.svg";
export { ForwardRef as ReactComponent };